import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { useCallback, useMemo } from 'react';
import Raven from 'raven-js';
import { useRemoveFromWatchLater } from '../../watchLater/watchLaterQueries';
import { useAddToWatchLater } from '../../watchLater/watchLaterQueries';
import { useWatchLater } from '../../watchLater/watchLaterQueries';
import UsageTracker from '../../../utils/UsageTracker';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useLatestSavedItemsInteractions } from '../savedItemsQueries';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const useToggleAddToWatchLater = ({
  id: assetId,
  type: containerType
}) => {
  const {
    data: allWatchLaterItems,
    loading: allWatchLaterItemsLoading
  } = useWatchLater({
    pageLength: 10000,
    // gets full saved items list
    contentTypes: [],
    offset: {
      cursor: 0
    },
    durationFilters: []
  });
  const [addToWatchLater, {
    loading: addToWatchLaterLoading
  }] = useAddToWatchLater({
    assetId,
    containerType: containerType
  });
  const [removeFromWatchLater, {
    loading: removeFromWatchLaterLoading
  }] = useRemoveFromWatchLater({
    assetId,
    containerType: containerType
  });
  const isItemAddedToWatchLater = useMemo(() => allWatchLaterItems === null || allWatchLaterItems === void 0 ? void 0 : allWatchLaterItems.results.some(({
    id,
    type
  }) => id === assetId && type === containerType), [allWatchLaterItems, assetId, containerType]);
  const toggleIsItemAddedToWatchLater = isItemAddedToWatchLater ? removeFromWatchLater : addToWatchLater;
  return {
    isItemAddedToWatchLater,
    toggleIsItemAddedToWatchLater,
    isToggleAddToWatchLaterLoading: addToWatchLaterLoading || removeFromWatchLaterLoading || allWatchLaterItemsLoading
  };
};
const CardMenuWatchLaterOption = ({
  item,
  render = content => {
    return /*#__PURE__*/_jsx(SideNavItem, {
      role: "navigation-item",
      title: content
    });
  },
  onClick
}) => {
  const {
    setLatestInteraction
  } = useLatestSavedItemsInteractions();
  const {
    isItemAddedToWatchLater,
    toggleIsItemAddedToWatchLater,
    isToggleAddToWatchLaterLoading
  } = useToggleAddToWatchLater(item);
  const handleOnClick = useCallback(() => {
    onClick === null || onClick === void 0 || onClick();
    if (isToggleAddToWatchLaterLoading) return;
    toggleIsItemAddedToWatchLater().then(() => {
      setLatestInteraction({
        itemId: item.id,
        type: item.type,
        language: item.language,
        action: isItemAddedToWatchLater ? 'REMOVE_FROM_WATCH_LATER' : 'ADD_TO_WATCH_LATER'
      });
      UsageTracker.track('interaction', {
        action: isItemAddedToWatchLater ? 'favorite-removed' : 'favorite-added',
        contentId: item.id,
        contentType: item.type
      });
    }).catch(Raven.captureException);
  }, [isItemAddedToWatchLater, isToggleAddToWatchLaterLoading, item, onClick, setLatestInteraction, toggleIsItemAddedToWatchLater]);
  return /*#__PURE__*/_jsx("div", {
    "aria-disabled": isToggleAddToWatchLaterLoading,
    "data-test-id": "watch-later-button",
    onClick: handleOnClick,
    children: render( /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx("span", {
        style: {
          flex: isToggleAddToWatchLaterLoading ? undefined : 1,
          opacity: isToggleAddToWatchLaterLoading ? 0.3 : 1
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: isItemAddedToWatchLater ? 'learningCenter.cardMenu.removeFromWatchLater' : 'learningCenter.cardMenu.addToWatchLater'
        })
      }), isToggleAddToWatchLaterLoading && /*#__PURE__*/_jsx(LoadingSpinner, {
        margin: "0",
        size: "extra-small"
      })]
    }))
  });
};
export default CardMenuWatchLaterOption;